import INVENTORY_API_BASE_URL from "../../config/api";
import "./ManageShipment.css";
import { useState, useEffect } from "react";

import Axios from "axios";

const ManageShipment = () => {
  const [data, setData] = useState([]);

  useEffect(() => {

    Axios.get(`${INVENTORY_API_BASE_URL}/getshipmentDetails`)
      .then((response) => {
       
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error retrieving shipment data:", error);
      });
  }, []);

  return (
    <div className="mana">
      <h2 className="heaSh">Manage Shipment Early Page</h2>

      <div className="shipcontainer">
        <div className="shipcontent">
          <table className="Shipshow">
            <thead>
              <th>Shipment_Id</th>
              <th>Title</th>
              <th>Medium</th>
              <th>No. of Boxes</th>
              <th>Total-Quantity</th>
              <th>Total-Weight(Kg)</th>
              <th>No. of Orders</th>
            </thead>
            <tbody>
              {data.map((row) => {
                return (
                  <tr key={row.ShipmentId}>
                    <td>{row.ShipmentId}</td>

                    <td>
                        {row.ShipmentDetails?.map((detail, detailIndex) => (
  <div key={detailIndex}>
    {detail.OrderDetails?.map((order, orderIndex) => (
      <div key={orderIndex}>{order.title}</div>
    ))}
  </div>
))}

                    </td>

                    <td>
                        {row.ShipmentDetails?.map((detail, detailIndex) => (
  <div key={detailIndex}>
    {detail.OrderDetails?.map((order, orderIndex) => (
      <div key={orderIndex}>{order?.Medium}</div>
    ))}
  </div>
))}

                    </td>

                    <td>{row.totalBoxes}</td>

                    <td>{row.totalQuantity}</td>

                    <td>{row.totalWeight.toFixed(2)}</td>

                    <td>{row.ShipmentDetails.length}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default ManageShipment;
